const stripe_test_workflow_pricingIds = {
    "expenses-tracker": "price_1S5uO4HVMu3GrLPXK8hhKYAI",
    "linkedin-jobhunter": "price_1SD4ieHVMu3GrLPXZ4GmVVs0",
    "marketassets-tracker": "price_1SD4oeHVMu3GrLPX9xuQ4T7p",
};

const stripe_live_workflow_pricingIds = {
    "expenses-tracker": "price_1SMBWFAmbUTivw1SRZKHJYFW",
    "linkedin-jobhunter": "price_1SMBaTAmbUTivw1STDU6JM0W",
    "marketassets-tracker": "price_1SMBawAmbUTivw1SQuk0ZD8L",
};

const getWorkflowPriceId = (workflow_name) => {
    const isLocal = process.env.REACT_APP_ENVIRONEMENT ? true : false;

    if (isLocal) {
        return stripe_test_workflow_pricingIds[workflow_name];
    }
    return stripe_live_workflow_pricingIds[workflow_name];
}

export const availableWorkflows = [
    {
        id: "6ae452c5-9d3f-40e6-9ece-cdfd047528c1",
        scheduled_trigger: false,
        workflow_name: "expenses-tracker",
        stripe_priceid: getWorkflowPriceId("expenses-tracker"),
        price_text: "€7.99/weekly",
        name: "Expenses Tracker",
        problem: "Manual expense logging is time-consuming and error-prone.",
        details: `Say goodbye to manual expense logging! Our comprehensive solution transforms how you manage finances through intelligent automation and seamless integrations.

Voice-Enabled Tracking
Simply speak your expenses and let AI handle the categorization and logging automatically.

Receipt Collection
Snap photos of receipts and our OCR technology extracts all relevant data automatically.

Telegram Integration
Forward receipts via Telegram and watch them automatically sync to your Google Drive with proper categorization.

Benefits
Gain clear insights into spending habits, reduce manual data entry by 95%, and maintain perfect expense records for tax season.`,
    },
    {
        id: "0745565a-c6df-4e0b-92ed-b8bd20c3c4cf",
        scheduled_trigger: true,
        workflow_name: "linkedin-jobhunter",
        stripe_priceid: getWorkflowPriceId("linkedin-jobhunter"),
        price_text: "€7.99/weekly",
        name: "LinkedIn Job Matcher",
        problem: "Finding relevant job opportunities is time-consuming and inefficient.",
        details: `Revolutionize your job search with AI-powered matching that scans thousands of opportunities and finds positions that align perfectly with your career goals.

CV Analysis
Advanced AI analyzes your CV to understand your skills, experience, and career trajectory.

Intelligent Matching
Our algorithm cross-references your profile with thousands of LinkedIn job postings in real-time.

Automated Monitoring
Continuous monitoring ensures you're among the first to know about relevant opportunities.

Results
Save 15+ hours per week on job searching while discovering opportunities you might have missed manually.`,
    },
    {
        id: "88d303ee-d213-47ff-b22e-57a90b23d200",
        scheduled_trigger: true,
        workflow_name: "marketassets-tracker",
        stripe_priceid: getWorkflowPriceId("marketassets-tracker"),
        price_text: "€7.99/weekly",
        name: "Market Assets Tracker",
        problem: "Gathering news and sentiment of assets daily is time-consuming and prevents tracking all your favorite assets efficiently.",
        details: `Stay ahead in your trading and investment decisions with daily AI-driven insights on your favorite assets.

News Aggregation
Our system scans the internet daily for news related to your selected assets.

Sentiment Analysis
AI evaluates the sentiment of news to give you an actionable overview of market mood.

Price Monitoring
Track price changes alongside news to make better-informed decisions.

Results
Save hours of research every day and get a clear picture of trends and sentiment affecting your investments.`,
    },
];